

























import { SelectedMerchantModel } from "@/model/merchant/selectedMerchantModel";
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const StoreLineToken = namespace("LineToken");
const StoreUserInfo = namespace("UserInfo");

@Component
export default class HeaderSet extends Vue {
  private scrollOver = false;
  private title = "";
  private merchant: SelectedMerchantModel | undefined | null = null;

  private color = "";

  @StoreLineToken.Getter
  private getLineAuthData!: any;
  @StoreLineToken.Getter
  private getLineTokenValidate!: boolean | null;

  @StoreUserInfo.Getter
  private getMerchant!: SelectedMerchantModel;

  @Watch("getLineTokenValidate", { immediate: true })
  getLineTokenValidateChanged() {
    this.SelectMerchant();
  }

  @Watch("$route", { immediate: true, deep: true })
  routeChanged(newVal: any, oldVal: any) {
    this.title = newVal.meta ? newVal.meta.title : "";
    this.SetColorPage(newVal.name);
  }

  mounted() {
    window.addEventListener("scroll", this.HandleScroll);
  }
  destroyed() {
    window.removeEventListener("scroll", this.HandleScroll);
  }

  public SetColorPage(routerName: string) {
    switch (routerName) {
      case "quotationCreate":
        this.color = "#6361F4";
        break;
      case "invoiceCreate":
        this.color = "#008DFF";
        break;
      case "receiptCreate":
        this.color = "#00BA67";
        break;
      case "expenseCreate":
        this.color = "#FFA350";
        break;
    }
  }

  public SelectMerchant() {
    if (this.getLineTokenValidate && this.getMerchant) {
      this.merchant = this.getMerchant;
    }
  }

  public HandleScroll() {
    this.scrollOver = window.scrollY > 0;
  }
}
